import Footer from "../Footer";
import Header from "../Header";

const Terms = () => {
  return (
    <div className="body">
      <Header />

      <div className="wrapper">
        <main className="page">
          <section className="legal-content">
            <div className="container-fix-width">
              <div className="legal-content-wrap">
                <h1 className="main-title">Terms of Service</h1>
                <p>
                  <strong>Effective Date</strong>: [May 01, 2025]
                </p>
                <p>
                  Welcome to <strong>SportBeagle</strong>! These Terms of
                  Service ("Terms") govern your access to and use of the
                  SportBeagle platform (referred to as "we", "our", or "us"). By
                  using the site or registering an account, you agree to be
                  legally bound by these Terms.
                </p>
                <p>
                  If you do not agree to these Terms, please do not use the
                  Service.
                </p>

                <h3>1. Description of Service</h3>
                <p>
                  SportBeagle is an informational and analytical platform that
                  helps users:
                </p>
                <ul>
                  <li>
                    Discover football matches using filters (league, country,
                    market, odds)
                  </li>
                  <li>Compare real-time odds from multiple bookmakers</li>
                  <li>
                    Access AI-based betting insights (available with
                    subscription)
                  </li>
                  <li>Make smarter, data-informed betting decisions</li>
                </ul>
                <p>
                  SportBeagle does <strong>not accept or process bets</strong>{" "}
                  and is <strong>not affiliated with any bookmaker</strong>. We
                  are an independent comparison and analytics tool.
                </p>

                <h3>2. Age & Legal Use</h3>
                <p>
                  You must be <strong>at least 18 years old</strong> or{" "}
                  <strong>of legal gambling age</strong> in your country of
                  residence to use this platform. You are solely responsible for
                  ensuring that the use of SportBeagle complies with the laws
                  and regulations in your jurisdiction.
                </p>

                <h3>3. Account Registration</h3>
                <p>
                  To use advanced features, users must register an account with:
                </p>
                <ul>
                  <li>A valid email address</li>
                  <li>A secure password</li>
                  <li>Optional personal information (e.g., name, phone)</li>
                </ul>
                <p>
                  You are responsible for maintaining the confidentiality of
                  your account and agree to notify us immediately of any
                  unauthorized use.
                </p>

                <h3>4. Subscriptions & Payments</h3>
                <p>
                  Some services are available only via a{" "}
                  <strong>paid subscription</strong>. By purchasing a
                  subscription, you agree:
                </p>
                <ul>
                  <li>
                    To be charged via a secure third-party payment processor
                  </li>
                  <li>
                    That all fees are billed in advance and are non-refundable,
                    unless otherwise stated by law
                  </li>
                  <li>
                    That you may cancel at any time; access will remain active
                    until the end of the billing period
                  </li>
                </ul>
                <p>We do not store or process any payment details directly.</p>

                <h3>5. Responsible Gaming</h3>
                <p>
                  SportBeagle promotes <strong>responsible gaming</strong> and
                  encourages all users to:
                </p>
                <ul>
                  <li>Bet only what they can afford to lose</li>
                  <li>Avoid chasing losses</li>
                  <li>Take breaks from betting</li>
                  <li>Seek help if betting becomes problematic</li>
                </ul>
                <p>
                  If you or someone you know is struggling with gambling, we
                  recommend visiting www.begambleaware.org or contacting a local
                  responsible gambling support organization.
                </p>
                <p>
                  SportBeagle is a <strong>tool</strong>, not a guarantee of
                  success. Use it with discipline and awareness.
                </p>

                <h3>6. Permitted Use</h3>
                <p>
                  You agree to use SportBeagle only for lawful, personal,
                  non-commercial purposes. You must not:
                </p>
                <ul>
                  <li>Resell or redistribute content</li>
                  <li>Use bots or scrapers to collect data</li>
                  <li>Interfere with the platform's normal operation</li>
                  <li>
                    Attempt to gain unauthorized access to systems or data
                  </li>
                </ul>
                <p>
                  We reserve the right to suspend or terminate accounts that
                  violate these conditions.
                </p>

                <h3>7. Intellectual Property</h3>
                <p>
                  All content on SportBeagle — including logos, design, data
                  sets, code, and AI models — is protected by copyright and
                  intellectual property laws. You may not reproduce, modify, or
                  redistribute any part without our express written consent.
                </p>

                <h3>8. Disclaimers & Limitation of Liability</h3>
                <p>
                  SportBeagle provides content <strong>"as is"</strong> for
                  informational purposes only. We do not make any guarantees
                  regarding:
                </p>
                <ul>
                  <li>Match outcomes</li>
                  <li>Accuracy of bookmaker odds</li>
                  <li>Future betting performance</li>
                </ul>
                <p>
                  You use this platform <strong>at your own risk</strong>.
                  SportBeagle is not liable for any financial loss or damage
                  resulting from your betting decisions.
                </p>

                <h3>9. International Users</h3>
                <p>
                  SportBeagle is available globally. By using it, you confirm
                  that you are{" "}
                  <strong>complying with the laws of your own country</strong>{" "}
                  regarding online gambling and data use.
                </p>
                <p>
                  Users from the <strong>European Union</strong> are protected
                  under the{" "}
                  <strong>General Data Protection Regulation (GDPR)</strong>,
                  and California residents are protected under the{" "}
                  <strong>California Consumer Privacy Act (CCPA)</strong>. For
                  details on how we handle your data, please refer to our{" "}
                  <strong>Privacy Policy</strong>.
                </p>

                <h3>10. Changes to Terms</h3>
                <p>
                  We may update these Terms from time to time. Updates will be
                  posted on this page, and the “Effective Date” will be updated
                  accordingly. Continued use of the platform constitutes your
                  acceptance of the revised Terms.
                </p>

                <h3>11. Termination</h3>
                <p>
                  You may stop using SportBeagle at any time. We reserve the
                  right to terminate or suspend accounts at our discretion,
                  especially if these Terms are violated.
                </p>

                <h3>12. Governing Law</h3>
                <p>
                  These Terms shall be governed by and interpreted in accordance
                  with the laws of [Insert your preferred jurisdiction, e.g.,
                  “England and Wales” or “the State of Delaware, USA”], without
                  regard to conflict of law principles.
                </p>

                <h3>13. Contact Us</h3>
                <p>
                  If you have any questions about these Terms, feel free to
                  reach out via our <strong>Contact Us</strong> page.
                </p>

                <h3>14. Company Information</h3>
                <p>
                  SportBeagle.com is owned and operated by DUBHELP, S.L.,{" "}
                  a company registered in Spain. CIF: B19877463.
                </p>
              </div>
            </div>
          </section>
        </main>
      </div>

      <Footer />
    </div>
  );
};

export default Terms;
